import { useRef, useState, memo } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import {
  ChevronLeft,
  ChevronRight,
  X,
  ShoppingCart,
  Share2
} from "lucide-react";

import "swiper/css";
import "swiper/css/navigation";
import "../styles/VideoSection.css";
import "../styles/modelvideogallery.css";
import { Link } from "react-router-dom";
import { useObsessionsinAction } from "../hooks/useObsessionsinAction";
function ObsessionsinAction() {
  const swiperRef = useRef(null);
  const [quantity, setQuantity] = useState(1);
  // MODAL STATE
  const [selectedIndex, setSelectedIndex] = useState(null);
  const {
    loopList,
    videoRefs,
    mutedIndex,
    toggleSound,
  } = useObsessionsinAction();

  // OPEN MODAL
  const openModal = (index) => {
    setSelectedIndex(index);
  };

  // CLOSE MODAL
  const closeModal = () => {
    setSelectedIndex(null);
  };

// NEXT MODAL
const nextModal = () => {

  // CURRENT VIDEO STOP
  if (videoRefs.current[selectedIndex]) {
    videoRefs.current[selectedIndex].pause();
    videoRefs.current[selectedIndex].currentTime = 0;
  }

  setSelectedIndex((prev) =>
    prev === loopList.length - 1 ? 0 : prev + 1
  );
};


// PREV MODAL
const prevModal = () => {

  // CURRENT VIDEO STOP
  if (videoRefs.current[selectedIndex]) {
    videoRefs.current[selectedIndex].pause();
    videoRefs.current[selectedIndex].currentTime = 0;
  }

  setSelectedIndex((prev) =>
    prev === 0 ? loopList.length - 1 : prev - 1
  );
};

  // QUANTITY
  const handleDecrease = () => {
    if (quantity > 1) {
      setQuantity(quantity - 1);
    }
  };

  const handleIncrease = () => {
    setQuantity(quantity + 1);
  };

 // cart Model Box -------------------------

  const [showBottomCart, setShowBottomCart] = useState(false);

  // ADD TO CART CLICK
  const handleAddToCart = () => {
     setShowBottomCart(true);
  };

  // CLOSE BOTTOM MODAL
  const closeBottomModal = () => {
    setShowBottomCart(false);
  };


  //------ Model box video sound Mute 

  return (
    <>
      <section className="videogallery-section">
        <div className="container">
          <div className="video-header" style={{ textAlign: "center", margin: "0 auto"}}>
            <h2 className="video-heading"> Obsessions in Action </h2>
            <p className="txt_sub_video_tag">
              See how our products blend into real homes,
              real moods, and real lifestyles.
            </p>
            <Link to="/reels" className="hero-button">
                  VIEW THE GALLERY
            </Link>
          </div>
        </div>

        <div className="container container-padding" style={{ maxWidth: "1440px" }} >
          <div className="product-swiper-wrapper">
            {/* MAIN SLIDER NAVIGATION */}
            <button
              className="custom-prev"
              onClick={() => swiperRef.current?.slidePrev()}
            >
              <ChevronLeft size={22} />
            </button>

            <button
              className="custom-next"
              onClick={() => swiperRef.current?.slideNext()}
            >
              <ChevronRight size={22} />
            </button>

            <Swiper
              modules={[Navigation]}
              onBeforeInit={(swiper) => {
                swiperRef.current = swiper;
              }}
              spaceBetween={20}
              slidesPerView={5}
              loop={true}
              speed={400}
              breakpoints={{
                320: { slidesPerView: 2.2 },
                480: { slidesPerView: 2.2 },
                768: { slidesPerView: 3 },
                1024: { slidesPerView: 5 },
              }}
            >
              {loopList.map((item, index) => (
                <SwiperSlide key={index}>
                  <div className="product-card">
                    <div className="image-box" onClick={() => openModal(index)}>
                      <video
                        ref={(el) =>
                          (videoRefs.current[index] = el)
                        }
                        src={item.uploaded_media}
                        poster={item.poster_image}
                        autoPlay
                        muted
                        playsInline
                        loop
                        className="video-item"
                        // onClick={() => toggleSound(index)}
                      />

                      {/* SOUND ICON */}
                      {/* <div className="sound-icon">
                        {mutedIndex === index ? (
                          <i className="bi bi-volume-up-fill"></i>
                        ) : (
                          <i className="bi bi-volume-mute-fill"></i>
                        )}
                      </div> */}
                    </div>

                    <div className="details pr-detials-section">
                      <h4 className="title-limit">
                        <Link to="/" target="_blank">
                          Reflexion Modern Abstract
                        </Link>
                      </h4>

                      <div className="price">
                        <span className="new">
                          ₹2250
                        </span>

                        <span className="old">
                          ₹2500
                        </span>

                        <span className="off">
                          10% OFF
                        </span>
                      </div>


                      {/* ADD TO CART BUTTON */}
                      <button
                        className="btn addtocat-button"
                        onClick={() => openModal(index)}
                       >
                        ADD TO CART
                      </button>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
   </section>


{/* ---- MODAL ---- */}

{selectedIndex !== null && (
  <div className="gallery-modal-overlay">

    {/* CLOSE BUTTON */}
    <button
      className="gallery-close-btn"
      onClick={closeModal}
     >
      <X size={20} />
    </button>

    {/* LEFT ARROW */}
    <button
      className="gallery-arrow left"
      onClick={prevModal}
    >
      <ChevronLeft size={30} />
    </button>

    {/* SLIDER CONTAINER */}

    <div className="gallery-slider-container">
      {/* SLIDER TRACK */}
      <div
        className="gallery-slider-track"
       style={{
          transform: `translateX(-${selectedIndex * 100}%)`,
        }}
       >
        {loopList.map((item, index) => (
          <div className="gallery-slide" key={index}>
            <div className="gallery-modal-wrapper">
              {/* LEFT SIDE VIDEO */}
              <div className="galleryleftvideo">
                <img
                  src={item?.poster_image}
                  alt=""
                  loading="lazy"
                />
              </div>

              <div className="gallery-modal-content">
                <div className="gallery-video-section">
                 <video
                      ref={(el) => (videoRefs.current[index] = el)}
                      src={item?.uploaded_media}
                      poster={item?.poster_image}
                      autoPlay={selectedIndex === index}
                      muted
                      loop
                      playsInline
                      controls
                      className="gallery-main-video"
                      onClick={() => toggleSound(index)}
                    />
                </div>

                <span className="shareicon">
                  <Share2 size={20} />
                </span>

                <span className="addbagcart">
                  <span className="cartcircle"> 0 </span>
                   <ShoppingCart size={22} />
                </span>

                {/* MOBILE DETAILS */}
                <div className="mobile-product-detial">
                  <div className="box-flex001">
                    <div>
                      <h2 className="heading">
                        Multi-Use Wooden Salad...
                      </h2>

                      <div className="gallery-price">
                        <span className="new-price">
                          ₹1,699
                        </span>

                        <span className="old-price">
                          ₹2,599
                        </span>

                        <span className="dis-sub">
                          10% OFF
                        </span>
                      </div>
                    </div>

                    <button className="shopNow" onClick={handleAddToCart}>
                      Add To Cart
                    </button>
                  </div>
                </div>

                {/* PRODUCT DETAILS */}

                <div className="gallery-product-details">
                  <div className="gallery-top-images-scroll">
                    <div className="gallery-top-images">
                      <img
                        src={item?.poster_image}
                        alt=""
                        style={{
                          width: "200px",
                          height: "200px",
                        }}
                        loading="lazy"
                      />

                      <img
                        src={item?.poster_image}
                        alt=""
                        style={{
                          width: "200px",
                          height: "200px",
                        }}
                        loading="lazy"
                      />

                      <img
                        src={item?.poster_image}
                        alt=""
                        style={{
                          width: "200px",
                          height: "200px",
                        }}
                        loading="lazy"
                      />

                      <img
                        src={item?.poster_image}
                        alt=""
                        style={{
                          width: "200px",
                          height: "200px",
                        }}
                        loading="lazy"
                      />

                    </div>
                  </div>

                  <h2>
                    Multi-Use Wooden Salad &
                    Snack Storage Box
                  </h2>

                  <div className="gallery-price">

                    <span className="new-price">
                      ₹1,699
                    </span>

                    <span className="old-price">
                      ₹2,599
                    </span>

                    <span className="dis-sub">
                      10% OFF
                      <span style={{ color: "#000" }}>
                        {" "}
                        (inc. of all taxes)
                      </span>
                    </span>

                  </div>

                  {/* QUANTITY */}
                  
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "9px",
                    }}
                   >
                    <span style={{ fontSize: "16px" }}>
                      Quantity
                    </span>

                    <div className="quantity-selector">

                      <button
                        className="qty-btn"
                        onClick={handleDecrease}
                      >
                        −
                      </button>

                      <input
                        type="number"
                        value={quantity}
                        readOnly
                        className="qty-input"
                      />

                      <button
                        className="qty-btn"
                        onClick={handleIncrease}
                      >
                        +
                      </button>
                    </div>
                  </div>

                  {/* SIZE */}
                  <div class="size-options">
                    <div class="size-btn active-size">
                      <div class="set_btn_trcak"></div>
                      <div class="lbl-track">30x35x51 cm</div>
                      </div><div class="size-btn ">
                        <div class="set_btn_trcak"></div>
                        <div class="lbl-track">30x35x51 cm</div>
                        </div><div class="size-btn ">
                          <div class="set_btn_trcak"></div>
                          <div class="lbl-track">30x35x51 cm</div>
                          </div>
                          </div>

                  {/* COLOR */}
                  <div className="color-selector">
                    <div className="color-label-st">
                      <p>
                        Select Color :
                        <span
                          style={{
                            fontWeight: "600",
                          }}
                        >
                          {" "}
                          Black
                        </span>
                      </p>
                    </div>

                    <div className="color-options">
                      <div className="selected-color active-size">
                        <div className="color-circle">
                          <img
                            alt="Black"
                            height="60"
                            width="60"
                            src="https://efi-s3-private.s3.ap-south-1.amazonaws.com/b2c-img/EnvogueImages/product/8907831025801/8907831025801.jpg"
                            loading="lazy"
                          />
                        </div>

                      </div>

                    </div>
                  </div>

                  {/* BUTTONS */}
                  <div className="gallery-btns">

                    <button className="cart-btn" >
                      Add to cart
                    </button>

                    <button
                      className="icon-cart"
                      style={{ visibility: "hidden" }}
                    >
                      <ShoppingCart size={22} />
                    </button>

                  </div>

                  {/* DESCRIPTION */}
                  <div className="gallery-description">
                    <h4>Description</h4>
                    <p>
                      Elevate your kitchen or restaurant
                      service with this handcrafted wooden
                      delicatessen cutting and serving board.
                    </p>

                  </div>
                </div>
              </div>

              {/* RIGHT SIDE VIDEO */}
              <div className="galleryrightvideo">
                <img
                  src={item?.poster_image}
                  alt=""
                  style={{ width: "249px" }}
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>

    {/* RIGHT ARROW */}
    <button
      className="gallery-arrow right"
      onClick={nextModal}
    >
      <ChevronRight size={30} />
    </button>
  </div>
)}

  {/* BOTTOM ---- MODAL---- BOX---- ADD TO CART */}

      <div
        className={`bottom-cart-modal ${
          showBottomCart ? "active" : ""
        }`}
      >

        {/* HEADER */}
        <div className="bottom-cart-header">
          {/* <h3>
            Product Added
          </h3> */}

          <button
            className="close-slide-btn"
            onClick={closeBottomModal}
          >
            <X size={22} />
          </button>

        </div>

        {/* BODY */}
        <div className="bottom-cart-body">
           <div className="select-Section-box"> 
               <div className="scrollingbody"> 
                  <div className="gallery-top-images-scroll">
                            <div className="gallery-top-images">
                              <img
                                src="https://efi-s3-private.s3.ap-south-1.amazonaws.com/b2c-img/EnvogueImages/product/8907831025801/8907831025801.jpg"
                                alt=""
                                style={{
                                  width: "200px",
                                  height: "200px",
                                }}
                                loading="lazy"
                              />

                              <img
                                src="https://efi-s3-private.s3.ap-south-1.amazonaws.com/b2c-img/EnvogueImages/product/8907831025801/8907831025801.jpg"
                                alt=""
                                style={{
                                  width: "200px",
                                  height: "200px",
                                }}
                                loading="lazy"
                              />

                              <img
                              src="https://efi-s3-private.s3.ap-south-1.amazonaws.com/b2c-img/EnvogueImages/product/8907831025801/8907831025801.jpg"
                                alt=""
                                style={{
                                  width: "200px",
                                  height: "200px",
                                }}
                                loading="lazy"
                              />

                              <img
                                src="https://efi-s3-private.s3.ap-south-1.amazonaws.com/b2c-img/EnvogueImages/product/8907831025801/8907831025801.jpg"
                                alt=""
                                style={{
                                  width: "200px",
                                  height: "200px",
                                }}
                                loading="lazy"
                              />
                            </div>
                      </div>
                  <div>
                    <h4>
                      Multi-Use Wooden Salad &
                      Snack Storage Box
                    </h4>
                   <div class="gallery-price">
                    <span class="new-price">₹1,699</span>
                    <span class="old-price">₹2,599</span>
                    <span class="dis-sub">10% OFF  <span style={{ color:"#000"}}> (inc. of all taxes)</span>  </span>
                  </div>

                   <div className="color-size-select">  
                     <div class="size-selector">
                      <p class="selected-size-label">Select Size :&nbsp;<strong> 30x45 cm </strong></p>
                      <div class="size-options">
                        <div class="size-btn active-size">
                          <div class="set_btn_trcak"></div>
                          <div class="lbl-track"> 30x45 cm </div>
                          </div>
                        <div class="size-btn ">
                            <div class="set_btn_trcak"></div>
                            <div class="lbl-track"> 40x60 cm </div>
                            </div>
                            <div class="size-btn ">
                              <div class="set_btn_trcak"></div>
                              <div class="lbl-track"> 50x70 cm </div>
                          </div>
                         <div class="size-btn ">
                          <div class="set_btn_trcak"></div>
                            <div class="lbl-track"> 50x70+50x45 cm </div>
                          </div>
                          <div class="size-btn ">
                            <div class="set_btn_trcak"></div>
                            <div class="lbl-track"> 60x150 cm </div>
                        </div>
                        </div>
                      </div>
                     <div class="color-selector">
                      <div class="color-label-st">
                        <p>Select Color :<span style={{ fontWeight:"600"}}> Black</span></p>
                        </div>
                        <div class="color-options">
                          <div class="selected-color active-size">
                            <div class="color-circle">
                              <img alt="Black" height="60" width="60" src="https://efi-s3-private.s3.ap-south-1.amazonaws.com/b2c-img/EnvogueImages/product/8907831025801/8907831025801.jpg" loading="lazy"/>
                              </div>
                              </div>
                        </div>
                     </div>
                     </div>
                      <h4> Discription</h4>
                      <p>This appealing Toothpick Holder by Obsessions is appealing, made of durable acrylic which is ideal for kitchen, dining table, picnic basket and office. Easy to clean and maintain. </p>
                    </div>      
                  </div>

           {/* BUTTON */}
              <button className="checkout-btn">
                    <ShoppingCart size={18} />
                      Go To Cart
              </button>
        </div>
       </div>
    </div>
    </>
  );
}
export default memo(ObsessionsinAction);